import type { Components, Theme } from '@mui/material/styles';

import { menuItem } from '../../styles/mixins';

const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
    styleOverrides: { root: ({ theme }) => ({ ...menuItem(theme) }) },
};

export const menu = { MuiMenuItem };
